module.exports = __webpack_public_path__ + "static/procesDystrybucjaMobile@x2-87d112492a3b10bc195570dc2181275d.png";